import ChemicalMap from './ChemicalMap'
import CertificateControl from './CertificateControl'

export {
	CertificateControl,
  ChemicalMap,
}



// WEBPACK FOOTER //
// ./src/containers/ProductMap/index.js